import React, { createContext, useContext, useState, useCallback } from "react";
import { FlyingCartAnimation } from "@/components/FlyingCartAnimation";

interface FlyingItem {
  id: string;
  startX: number;
  startY: number;
  imageUrl?: string;
}

interface FlyingCartContextType {
  triggerFlyAnimation: (startX: number, startY: number, imageUrl?: string) => void;
}

const FlyingCartContext = createContext<FlyingCartContextType | undefined>(undefined);

export const FlyingCartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [flyingItems, setFlyingItems] = useState<FlyingItem[]>([]);

  const triggerFlyAnimation = useCallback((startX: number, startY: number, imageUrl?: string) => {
    const id = `fly-${Date.now()}-${Math.random()}`;
    setFlyingItems((prev) => [...prev, { id, startX, startY, imageUrl }]);
  }, []);

  const handleAnimationComplete = useCallback((id: string) => {
    setFlyingItems((prev) => prev.filter((item) => item.id !== id));
  }, []);

  return (
    <FlyingCartContext.Provider value={{ triggerFlyAnimation }}>
      {children}
      <FlyingCartAnimation items={flyingItems} onComplete={handleAnimationComplete} />
    </FlyingCartContext.Provider>
  );
};

export const useFlyingCart = () => {
  const context = useContext(FlyingCartContext);
  if (!context) {
    throw new Error("useFlyingCart must be used within FlyingCartProvider");
  }
  return context;
};
